module.exports = __webpack_public_path__ + "public/img/img_Model@2x.069cb7fc.png";